export default __webpack_public_path__ + "static/media/katharina-roehler-uRVrsWt-7mU-unsplash.59239325.webp";